let mapImageUrl: undefined | ((imageId: string) => string) = undefined;

function setMapImageUrl(mapper: typeof mapImageUrl) {
    mapImageUrl = mapper;
}

export { mapImageUrl, setMapImageUrl };
